<template>
	<div class="hit-row">
		<div class="hit-col-md-6 hit-col-md-hit-offset-3">

			<div class="hit-panel hit-panel-primary hit-html-html">
				<div class="hit-panel-heading">
					{{ $t('message.signUp') }}
				</div>
				<div class="hit-panel-body">

					<div class="hit-col-md-12">
						<div class="hit-form-group">
							<div class="hit-input-group">
				        <div  class="hit-input-group-addon ">
				          <i class="hit-glyphicon hit-glyphicon-user" v-bind:class="check_username"></i>
				        </div>
								<input type="text" id="username" class="hit-form-control" spellcheck="false" v-model="username"  v-bind:placeholder="$t('message.username')">
							</div>
						</div>
					</div>

					<div class="hit-col-md-12">
						<div class="hit-form-group">
							<div class="hit-input-group">
				        <div  class="hit-input-group-addon">
				          <i class="hit-glyphicon hit-glyphicon-envelope" v-bind:class="check_email"></i>
				        </div>
								<input type="text" id="email" spellcheck="false" v-model="email" class="hit-form-control" v-bind:placeholder="$t('message.email')">

							</div>

						</div>
					</div>

					<div class="hit-col-md-6">
					<div class="hit-form-group">
						<div class="hit-input-group">
							<div  class="hit-input-group-addon">
								<i class="hit-glyphicon hit-glyphicon-lock" v-bind:class="check_password"></i>
							</div>
							<input type="password" class="hit-form-control" v-bind:placeholder="$t('message.password')" v-model="password">
						</div>
					</div>
					</div>

					<div class="hit-col-md-6">
					<div class="hit-form-group">
						<div class="hit-input-group">
							<div  class="hit-input-group-addon">
								<i class="hit-glyphicon hit-glyphicon-lock" v-bind:class="check_password2"></i>
							</div>
							<input type="password" class="hit-form-control" v-bind:placeholder="$t('message.repeatPassword')" v-model="password2">
						</div>
					</div>
					</div>

					<div class="hit-col-md-12">
						<div class="hit-form-group"  style="cursor:pointer;">
							<div class="hit-input-group">
				        <div  class="hit-input-group-addon" v-on:click="change_agb()">
				          <span v-show="!agb" class="hit-glyphicon hit-glyphicon-unchecked hit-text-danger" ></span>
				          <span v-show="agb" class="hit-glyphicon hit-glyphicon-check hit-text-success"></span>
				        </div>
								<div class="hit-form-control" v-on:click="change_agb()">{{ $t('message.acceptTerms') }}</div>
							</div>
						</div>
					</div>
					<div class="hit-col-md-12">
						<div class="hit-form-group hit-text-right">
					<router-link class="hit-html-a" :to="{ name: 'terms', params: {lang: $store.getters.lang} }">{{ $t('message.goTo', {name: $t('message.terms')}) }}</router-link>
						</div>
					</div>

					<transition name="fade">
						<div class="hit-col-md-12" v-bind:key="check_error()" v-show="check_error()">
							<div class="hit-form-group">
								<button type="submit" class="hit-btn hit-btn-primary hit-btn-block" v-on:click.prevent="send_form">{{ $t('message.signUp') }}</button>
							</div>
						</div>
					</transition>

				</div>

				<div class="hit-panel-footer">
						<router-link class=" hit-html-a" :to="{ name: 'sign_in', params: {lang: $store.getters.lang} }">{{ $t('message.alreadyAccount') }}</router-link>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default{
  name: 'sign_up',
  props: {callback: Function},

  data () {
    return {
      username: '',
      agb: false,
      password: '',
      email: '',
      check_username: { },
      check_email: {},
      check_password2: {},
      check_password: {},
      password2: '',
      error: {
        password: true,
        password2: true,
        username: true,
        email: true,
        agb: true
      }
    }
  },
  watch: {
    username: function (value) { value = this.change_username(value); this.username = value; if (value.length < 4) { this.check_username = {'hit-text-danger': true}; this.error.username = true } else { this.check_username = {'hit-text-success': true}; this.error.username = false } },
    email: function (value) { if (!this.validateEmail(value)) { this.check_email = {'hit-text-danger': true}; this.error.email = true } else { this.check_email = {'hit-text-success': true}; this.error.email = false } },
    password2: function (value) { this.compare_password() },
    password: function (value) { this.compare_password(); if (value.length < 4) { this.check_password = {'hit-text-danger': true}; this.error.password = true } else { this.check_password = {'hit-text-success': true}; this.error.password = false } }

  },
  methods: {

    send_form: function () {
      var link = this.$get_url().www_url + this.$router.resolve({ name: 'register_confirm',
        params: {
	        lang: this.$route.params.lang,
	        userID: '{{userID}}'
	        }
	      }).href

      var send = {
        username: this.username,
        email: this.email,
        password: this.password,
        url: link
      }

      this.$hit_post({url: 'hitclick/user/register', data: send, callback: function (ret) { console.log(ret); if (ret.data[0]) { this.callback(ret.data) } }.bind(this)})
    },

    check_error: function () {
      var check = true

      Object.values(this.error).forEach(function (key) {
        if (key === true) {
          check = false
          return false
        }
      })

      return check
    },

    change_username: function (value) {
      var username = value
		    username = username.replace(/[^a-zA-Z ]/g, '')
		    username = username.replace(' ', '')
		    username = username.toLowerCase()

      return username
    },
    change_agb: function () { this.agb = !this.agb; this.error.agb = !this.agb },
    validateEmail: function (email) {
			    var re = /\S+@\S+\.\S+/
			    return re.test(email)
    },
    compare_password: function () { if (this.password != this.password2 || this.password == '') { this.check_password2 = {'hit-text-danger': true}; this.error.password2 = true } else { this.check_password2 = {'hit-text-success': true}; this.error.password2 = false } }
  },

  metaInfo: function () {
	    return {
	     title: this.$t('message.signUp')
	   }
	 }
}
</script>
